export const RewardType = {
  XP_BOOST: 'xpBoost',
  MERCH_DISCOUNT: 'merchDiscount',
  STREAK_FREEZE: 'streakFreeze',
} as const;

export type RewardType = (typeof RewardType)[keyof typeof RewardType];

export const RewardStatus = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  INACTIVE: 'inactive',
} as const;

export type RewardStatus = (typeof RewardStatus)[keyof typeof RewardStatus];

export const SourceType = {
  WEEKLY_MISSION: 'weekly-mission',
  CONTENT_DROP: 'content-drop',
  CTF: 'ctf',
  LEAGUE: 'league',
  BRONZE_RAFFLE: 'bronze-raffle',
  RAFFLE_ENTRY: 'raffle-entry',
  MODULE_COMPLETION: 'module-completion',
} as const;

export type SourceType = (typeof SourceType)[keyof typeof SourceType];

export type ActivateRewardData = {
  rewardId: string;
  rewardType: RewardType;
  activatedAt?: string;
  status: RewardStatus;
  source: SourceType;
  metadata?: Record<string, unknown>;
  xpBoost?: {
    multiplier: number;
    /**
     * Total configured boost duration in minutes
     */
    totalDurationMinutes: number;
    expiresAt?: string;
  };
  merchDiscount?: {
    percentage: number;
    code: string;
  };
  streakFreeze?: {
    count: number;
  };
};

export type ActivateRewardResult = { success: true; data: ActivateRewardData } | { success: false; error: string };

export interface XpBreakdown {
  bonusXp: number;
  totalXp: number;
  multiplier: number;
  multiplierSource: 'content-drop' | 'xp-boost' | 'none';
}
